export const issn = '10009';
export const token_type = 'token-moss';
export const url_dev = 'http://172.30.1.101:9000';
export const url_production = (window.location.hostname.indexOf("192.") >= 0 ) ?'http://172.30.1.101:9000' : 'https://api-moss.17m3.com';

//const host =(process.env.NODE_ENV == 'development' || window.location.hostname.indexOf("192.") >= 0 )  ? 'http://172.30.1.101:9000/' : '//api-moss.17m3.com/';
//const webUrl = (process.env.NODE_ENV == 'development' || window.location.hostname.indexOf("192.") >= 0 ) ? (location.origin + location.pathname): 'https://www.m3guo.com/activity/202603/ad7u75/';